import { computed } from 'vue'
import { capsFor } from '../constants/campaign-capabilities.js'

export function useCampaign(campaign) {
  const caps = computed(() => capsFor(campaign.value?.type))

  const supportsContributions = computed(() => !!caps.value.contributions)
  const supportsParticipants  = computed(() => !!caps.value.participants)
  const supportsItems         = computed(() => !!caps.value.items)
  const supportsCycles        = computed(() => !!caps.value.cycles)
  const supportsBids          = computed(() => !!caps.value.bids)
  const supportsPayouts       = computed(() => !!caps.value.payouts)

  const progressPct = computed(() => {
    const c = campaign.value
    if (!c) return 0
    if (c.targetAmountCfa)   return clampPct((c.currentAmountCfa   / c.targetAmountCfa)   * 100)
    if (c.targetQuantity)    return clampPct((c.currentQuantity    / c.targetQuantity)    * 100)
    if (c.maxParticipants)   return clampPct((c.currentParticipants / c.maxParticipants)  * 100)
    return 0
  })

  const goalLabel = computed(() => {
    const c = campaign.value
    if (!c) return ''
    if (c.targetAmountCfa)
      return `${fmtCfa(c.currentAmountCfa)} / ${fmtCfa(c.targetAmountCfa)}`
    if (c.targetQuantity)
      return `${c.currentQuantity} / ${c.targetQuantity} unités`
    if (c.maxParticipants)
      return `${c.currentParticipants} / ${c.maxParticipants} places`
    return ''
  })

  const isClosed = computed(() =>
    ['COMPLETED', 'CANCELLED', 'EXPIRED'].includes(campaign.value?.status))

  function fmtCfa(n) {
    return `${Math.round(n ?? 0).toLocaleString('fr-FR')} CFA`
  }

  function clampPct(n) {
    return Math.max(0, Math.min(100, Math.round(n)))
  }

  return {
    supportsContributions, supportsParticipants,
    supportsItems, supportsCycles, supportsBids, supportsPayouts,
    progressPct, goalLabel, isClosed, fmtCfa,
  }
}
